import React, { createContext, useContext, useState, useCallback } from 'react';

export type ProductType = '' | 'Imported' | 'Produced';

interface ProductTypeContextType {
  productType: ProductType;
  setProductType: (type: ProductType) => void;
}

const ProductTypeContext = createContext<ProductTypeContextType>({
  productType: '',
  setProductType: () => {},
});

export function useProductType() {
  return useContext(ProductTypeContext);
}

export function ProductTypeProvider({ children }: { children: React.ReactNode }) {
  const [productType, setProductTypeState] = useState<ProductType>(() => {
    try {
      return (localStorage.getItem('suryaiq_product_type') as ProductType) || '';
    } catch {
      return '';
    }
  });

  const setProductType = useCallback((type: ProductType) => {
    setProductTypeState(type);
    try {
      if (type) {
        localStorage.setItem('suryaiq_product_type', type);
      } else {
        localStorage.removeItem('suryaiq_product_type');
      }
    } catch {
      // localStorage unavailable
    }
  }, []);

  return (
    <ProductTypeContext.Provider value={{ productType, setProductType }}>
      {children}
    </ProductTypeContext.Provider>
  );
}
